"use client";

import Link from "next/link"
import { usePathname } from "next/navigation";
import HomeIcon from "@/public/images/mobile/nav/home.svg";
import MarketIcon from "@/public/images/mobile/nav/market.svg";
import BotIcon from "@/public/images/mobile/nav/bot.svg";
import ManagementIcon from "@/public/images/mobile/nav/management.svg";
import InfoIcon from "@/public/images/mobile/nav/info.svg";
import HomeIconActive from "@/public/images/mobile/nav/home-active.svg";
import MarketIconActive from "@/public/images/mobile/nav/market-active.svg";
import BotIconActive from "@/public/images/mobile/nav/bot-active.svg";
import ManagementIconActive from "@/public/images/mobile/nav/management-active.svg";
import InfoIconActive from "@/public/images/mobile/nav/info-active.svg";




export const NavigationMobile = () => {
  const pathname = usePathname();

  return (
    <div className="mo-safe-padding">
      <nav className="mo-header">
        <Link
          href="/v2"
          className={`mo-nav-item ${pathname === "/v2" ? "opacity-100" : "opacity-[0.58]"}`}
        >
          {pathname === "/v2" ? (
            <HomeIconActive width={18} height={18} />
          ) : (
            <HomeIcon width={18} height={18} />
          )}
          <span>홈</span>
        </Link>

        <Link
          href="/v2/market"
          className={`mo-nav-item ${pathname.includes("/v2/market") ? "opacity-100" : "opacity-[0.58]"}`}
        >
          {pathname.includes("/v2/market") ? (
            <MarketIconActive width={18} height={18} />
          ) : (
            <MarketIcon width={18} height={18} />
          )}
          <span>마켓</span>
        </Link>

        <Link
          href="/v2/bot"
          className={`mo-nav-item ${pathname.includes("/v2/bot") ? "opacity-100" : "opacity-[0.58]"}`}
        >
          {pathname.includes("/v2/bot") ? (
            <BotIconActive width={18} height={18} />
          ) : (
            <BotIcon width={18} height={18} />
          )}
          <span>자동매매</span>
        </Link>

        <Link
          href="/v2/manage"
          className={`mo-nav-item ${pathname.includes("/v2/manage") ? "opacity-100" : "opacity-[0.58]"}`}
        >
          {pathname.includes("/v2/manage") ? (
            <ManagementIconActive width={18} height={18} />
          ) : (
            <ManagementIcon width={18} height={18} />
          )}
          <span>관리</span>
        </Link>

        <Link
          href="/v2/profile"
          className={`mo-nav-item ${pathname.includes("/v2/profile") || pathname.includes("/v2/profit")
              ? "opacity-100"
              : "opacity-[0.58]"
            }`}
        >
          {pathname.includes("/v2/profile") || pathname.includes("/v2/profit") ? (
            <InfoIconActive width={18} height={18} />
          ) : (
            <InfoIcon width={18} height={18} />
          )}
          <span>내 정보</span>
        </Link>
      </nav>
    </div>
  )
}